import axios from "axios";
import { SERVER_URL } from "../config";
import { authHeader } from "../helpers";
import { handleResponse, handleError } from "../helpers";

let baseRoute = SERVER_URL;

export const reportService = {
  getLeadAndSaleOpportunityReport,
  getManagerReport,
};

function getLeadAndSaleOpportunityReport(params) {
  console.log("into reportService");

  return axios
    .post(`${baseRoute}/report`, params, { headers: authHeader() })
    .then((res) => {
      return handleResponse(res);
    })
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
    });
}

function getManagerReport(params) {
  return axios
    .post(`${baseRoute}/report/manager`, params, { headers: authHeader() })
    .then((res) => handleResponse(res))
    .catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        handleError(error.response.status);
      }
      return undefined;
    });
}
